import React, { useEffect, useState } from "react";
import _ from "lodash";
import InputText from "../Input/text";
import { requestAuthGet } from "../../api/authInstance";
import { useAuth } from "../auth/authContext";
import InformationSheet from "../Sheet/InformationSheet";
import { GetDataOptions } from "../../utils/Utils";
import InputSelect from "../Input/InputSelect";
import Button from "../Button/Button";
import FormTextArea from "../Input/FormTextArea";
import "react-spring-bottom-sheet/dist/style.css";
import ModalBottom from "./ModalBottom";

export default function ModalDcmForm({
  showModal,
  setShowModal,
  setData,
  data,
  type,
  dataCount,
  showConfirmation,
  setShowConfirmation,
  balance,
}) {
  const { userData } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const [options, setOptions] = useState({});

  const [isLoadingForm, setIsLoadingForm] = useState(false);

  const defaultInvalid = {
    phone: null,
  };
  const [invalid, setInvalid] = useState(defaultInvalid);

  // sheet state
  const [sheetDetail, setSheetDetail] = useState({
    title: "",
    detail: "",
    open: false,
  });

  const handleInvalidChange = (name, value) => {
    setInvalid((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const FilterData = [
    {
      url: `project?retailer=${userData?.outlet?.retailer?.id ?? ""}&type=6f04a3c4-76bb-4a2a-89e4-57fea266fb16&limit=99999`,
      label: "alias",
      key: "id",
      name: "project",
    },
  ];

  useEffect(() => {
    GetDataOptions(FilterData, setOptions, setIsLoadingForm);
    return () => {
      setOptions({});
    };
  }, []);

  useEffect(() => {
    if (showModal && data.project) {
      GetDataCount();
    }
  }, [data.project]);

  const GetDataCount = async () => {
    requestAuthGet("ewallet-submission/count", {
      params: { project: data.project },
    }).then((res) => {
      const length = res.data.data;
      setData({
        ...data,
        identifier: `${data.projectName.substring(0, 3).trim()}-${String(length + 1).padStart(3, "0")}-${new Date()
          .toLocaleDateString("id-ID", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
          })
          .replace(/\//g, "")}`,
      });
    });
  };

  return (
    <>
      {/* Modal ADD User */}
      <ModalBottom
        showModal={showModal}
        setShowModal={setShowModal}
        onClose={() => setData({})}
        defaultHeight={0.9}
        title="Ajukan Proposal"
        footer={
          <div className="">
            <div className="grid grid-cols-2 space-x-2">
              <Button
                onClick={() => {
                  setShowModal(false);
                  setData({});
                }}
                fullWidth
                size="sm"
                disabled={isLoading}
                label="Kembali"
                variant="default"
              />
              <Button
                onClick={() => {
                  setShowModal(false);
                  setShowConfirmation(true);
                }}
                label="Ajukan"
                disabled={
                  !data.project ||
                  !data.identifier ||
                  !data.nominal ||
                  isLoading
                }
                fullWidth
                size="sm"
                variant="gradient"
              />
            </div>
          </div>
        }
      >
        <div className="space-y-3">
          <InputSelect
            name="project"
            label="Pilih Project"
            placeholder="Project"
            disabled={isLoading}
            options={options.project?.data}
            relative
            shouldScrollIntoView
            value={
              _.find(options.project?.data, {
                value: data.project,
              }) ?? null
            }
            onChange={(e) => {
              setData({
                ...data,
                project: e.value,
                projectName: e.name,
              });
            }}
          />
          <InputText
            name="balance"
            placeholder="0"
            label="Saldo Deposit"
            type="tel"
            disabled
            value={
              balance && data.project ? balance.toLocaleString("id-ID") : "0"
            }
            prefix="Rp."
          />
          <InputText
            name="identifier"
            label="ID Proposal"
            placeholder="ID Proposal"
            type="email"
            disabled
            value={data.identifier ?? "PRO-000-0000"}
            onChange={(e) =>
              setData((prevState) => ({
                ...prevState,
                identifier: e.target.value,
              }))
            }
            validationString="email"
            errorMessage={"Invalid email address"}
          />

          <InputText
            name="balance"
            placeholder="0"
            label="Masukkan Nilai Pengajuan"
            disabled={isLoading || !data.project}
            value={
              data?.nominal
                ? data.nominal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
                : ""
            }
            onChange={(e) => {
              let value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
              const numericValue = parseInt(value, 10); // Convert to a number

              if (numericValue > balance) {
                // Prevent value from exceeding balance
                value = balance.toString();
              }

              value = value.replace(/\B(?=(\d{3})+(?!\d))/g, "."); // Format as currency

              setData((prevState) => ({
                ...prevState,
                nominal: value.replace(/\./g, ""), // Store raw numeric value
              }));
            }}
            prefix="Rp."
            validationString="nullable"
          />
          <FormTextArea
            name="reason"
            placeholder="Masukkan Tujuan Pengajuan"
            className={`form-input w-full`}
            label="Tujuan Pengajuan"
            type="text"
            disabled={isLoading}
            rows={4}
            value={data?.descriptions ?? ""}
            onChange={(e) =>
              setData((prevState) => ({
                ...prevState,
                descriptions: e.target.value,
              }))
            }
          />
        </div>
      </ModalBottom>
      <InformationSheet
        sheetDetail={sheetDetail}
        setSheetDetail={setSheetDetail}
      />
    </>
  );
}
